import Swiper from "swiper";

export default function(el) {
    const heroSliderEl = el.querySelector(".rh__swiper--hero");
    const logosSliderEl = el.querySelector(".rh__swiper--logos");

    if (!heroSliderEl || !logosSliderEl) return;

    const heroSlider = new Swiper(heroSliderEl, {
        loop: true,
        allowTouchMove: false,
    });

    const logosSlider = new Swiper(logosSliderEl, {
        loop: true,
        grabCursor: true,
        slidesPerView: "auto",
        centeredSlides: true,
        slideToClickedSlide: true,
        navigation: {
            nextEl: el.querySelector(".rh__button--next"),
            prevEl: el.querySelector(".rh__button--prev"),
        },
        on: {
            slideChange: (swiper) => {
                heroSlider.slideTo(swiper.realIndex + 1);
            },
        },
    });
}
